/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
// ordered so the highest default priority has the largest integer. this allows for number sums to be
// followed downward without risk of preference knocking things out of whack.
export var Positions;
(function (Positions) {
    Positions[Positions["Responsive"] = 0] = "Responsive";
    Positions[Positions["Top"] = 1] = "Top";
    Positions[Positions["Left"] = 2] = "Left";
    Positions[Positions["TopOrLeft"] = 3] = "TopOrLeft";
    Positions[Positions["Right"] = 4] = "Right";
    Positions[Positions["TopOrRight"] = 5] = "TopOrRight";
    Positions[Positions["Horizontal"] = 6] = "Horizontal";
    Positions[Positions["TopOrHorizontal"] = 7] = "TopOrHorizontal";
    Positions[Positions["Bottom"] = 8] = "Bottom";
    Positions[Positions["Vertical"] = 9] = "Vertical";
    Positions[Positions["BottomOrLeft"] = 10] = "BottomOrLeft";
    Positions[Positions["VerticalOrLeft"] = 11] = "VerticalOrLeft";
    Positions[Positions["BottomOrRight"] = 12] = "BottomOrRight";
    Positions[Positions["VerticalOrRight"] = 13] = "VerticalOrRight";
    Positions[Positions["BottomOrHorizontal"] = 14] = "BottomOrHorizontal";
    Positions[Positions["All"] = 15] = "All";
})(Positions || (Positions = {}));
